import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "react-bootstrap";
import { CustomModal } from "@services/ui-components";
import { ButtonProps } from "@services/ui-components/src/Modal/CustomModal";

interface ConfirmDisabledMenuTypesModalProps {
    show: boolean;
    menuTypeLabels: string[];
    confirmText: string;
    onCancel: () => void;
    onConfirm: () => void;
}

const ConfirmDisabledMenuTypesModal: React.FC<ConfirmDisabledMenuTypesModalProps> = ({
    show,
    menuTypeLabels,
    confirmText,
    onCancel,
    onConfirm,
}) => {
    const { t } = useTranslation();
    const menuTypes = menuTypeLabels.map((menuTypeLabel) => `"${menuTypeLabel}"`).join(", ");
    const isMultiple = menuTypeLabels.length > 1;

    const buttons: ButtonProps[] = useMemo(
        () => [
            {
                text: t("Cancel"),
                variant: "outline-primary",
                className: "w-100",
                onClick: onCancel,
                type: "button",
            },
            {
                text: confirmText,
                variant: "primary",
                className: "w-100",
                onClick: onConfirm,
                type: "button",
            },
        ],
        [confirmText, onCancel, onConfirm, t]
    );

    return (
        <CustomModal
            show={show}
            handleClose={onCancel}
            title={
                isMultiple
                    ? t("Remove from all menus of the following types: {{menuTypes}}?", { menuTypes })
                    : t("Remove from all menus of type {{menuTypes}}?", { menuTypes })
            }
            body={
                <Container>
                    <div className="text-center text-dark">
                        <p className="mb-3">
                            <>
                                {isMultiple
                                    ? t("This dish is already used in menus of the following types: {{menuTypes}}.", {
                                          menuTypes,
                                      })
                                    : t("This dish is already used in a menu of type {{menuTypes}}.", {
                                          menuTypes,
                                      })}
                            </>{" "}
                            {t(
                                "If you disable availability, the dish will be automatically removed from all related menus."
                            )}
                        </p>
                        <p className="mb-0">{t("Are you sure you want to continue?")}</p>
                    </div>
                </Container>
            }
            headerAlignment="start"
            buttons={buttons}
        />
    );
};

export default ConfirmDisabledMenuTypesModal;
